<template>
<div>
    <div class="box mt-5">
        <div class="row">
            <div class="col-md-12 m-3">
                <h3>Booking History</h3>
            </div>
        </div>
        <hr />
        <div class="row p-3 mb-4">
            <div class="row">
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-12">
                            <h6>History Date Range</h6>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-6">
                            <dateTimePicker
                                no-label
                                label="From Date"
                                id="departureDateStart"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                v-model="searchFields.dateStart"
                                button-color="#ec391e"
                                :only-date="true"
                                color="#ec391e"
                                style="border: 1px solid #DFE5F9"
                            />
                            <small class="text-danger" v-if="errors.date_start">{{ errors.date_start }}</small>
                        </div>
                        <div class="col-md-6">
                            <dateTimePicker
                                no-label
                                label="To Date"
                                id="departureDateEnd"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                v-model="searchFields.dateEnd"
                                button-color="#ec391e"
                                :only-date="true"
                                color="#ec391e"
                                style="border: 1px solid #DFE5F9"
                                :min-date="searchFields.dateStart"
                            />
                            <small class="text-danger" v-if="errors.date_end">{{ errors.date_end }}</small>
                        </div>
                    </div>
                </div>
                <div class="col-md-2" style="margin-top: 2.5rem;">
                    <button class="button button--primary" @click="doSearch">
                        Search
                    </button>
                    <button class="button button--primary" @click="resetSearch">
                        <span class="icon icon--reload"></span>
                    </button>

                </div>
            </div>
        </div>
        <hr/>
        <div class="row">
            <div class="col-md-12">
                <vdtnet-table
                    ref="table"
                    :fields="fields"
                    :opts="options"
                    :key="tableKey"
                    @viewRawLog="viewRawLog"
                    @resendEmail="resendEmail"
                    @showDownloadHistory="showDownloadHistory"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <!-- Mailgun Raw Modal -->
                <div class="modal-lg" v-if="showMailgunRawData == true">
                <div class="modal__content">
                    <div class="modal__header">
                    <h4 class="modal__title">Mailgun Event Raw Data</h4>
                    </div>
                    <div class="modal__body">
                    <div class="details">
                        <pre><code class="json"></code></pre>
                    </div>
                    <button type="button" class="icon icon--unlink" v-on:click="showMailgunRawData = false">Close</button>
                    </div>
                    <div class="modal__bg" v-if="showMailgunRawData == true"></div>
                    <!-- Mailgun Raw Modal -->
                </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="modal-sm" v-if="showDownloadHistoryModal == true">
                    <div class="modal__content">
                        <div class="modal__header">
                            <h4 class="modal__title">Document Download History</h4>
                        </div>
                        <div class="modal__body">
                            <div class="row">
                                <div class="col-md-12">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>Message</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="history in recordDownloadHistory" :key="history.id">
                                                <td>{{ $options.filters.formatDateTime(history.created_at) }}</td>
                                                <td>{{ history.action_message }}</td>
                                                <td> <span class="badge" :class="(history.action_type == 'success') ? 'badge-success' : 'badge-danger'">{{ history.action_type }}</span></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button type="button" class="icon icon--unlink" v-on:click="showDownloadHistoryModal = false">Close</button>
                </div>
                <div class="modal__bg" v-if="showDownloadHistoryModal == true"></div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import 'datatables.net'
import VdtnetTable from 'vue-datatables-net'

export default {
    name: 'BookingHistory',
    props : {
        bookingID: Number,
    },
    components: {
        VdtnetTable,
    },
    mounted() {
        this.addDocumentClickHandler();
    },
    watch: {
        tableKey() {
            this.$nextTick(() => {
                this.addDocumentClickHandler();
            });
        }
    },
    data () {
        return {
            options: {
                ajax: {
                    url: `${this.$api}${this.bookingID}/get-booking-history`,
                    type:'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': localStorage.getItem('token')
                    }
                },
                responsive: false,
                processing: true,
                searching: true,
                searchDelay: 1500,
                destroy: true,
                ordering: true,
                lengthChange: true,
                serverSide: true,
                dom: 'rtlip',
                autoWidth: false,
                lengthMenu: [ [15,25, 50, 100, 500], [15,25, 50, 100, 500] ],
                pageLength: 15,
                columnDefs: [
                    { targets: "_all", className: "text-wrap" } // custom class to wrap
                ],
            },
            fields: {
                created_at: {
                    label: 'Date',
                    render: (data) => {
                        return data
                    }
                },
                user: {
                    label: 'Added By',
                    render: (data) => {
                        return (data) ? data.name : '--'
                    }
                },
                type: {
                    label: 'Type',
                    render: (data) => {
                        return data
                    }
                },
                action: {
                    label: 'Action',
                    render: (data) => {
                        return data
                    }
                },
                comment: {
                    label: 'Comment',
                    render: (data, t, f, m) => {
                        let html = data
                        // If There's any download History
                        if (f.download_history.length > 0) {
                            html +=` &nbsp <button class="button--small btn-outline-info" data-action="showDownloadHistory">
                                <span class="icon icon--eye"></span>
                            </button>`
                        }

                        if (f.is_multiple) {
                            html += `<br>
                                <hr/>`
                            if (f.multiple_documents_attached.length > 0) {
                                html += `<ul>`
                                f.multiple_documents_attached.forEach(element => {
                                    const encoded = encodeURIComponent(JSON.stringify({
                                        id: f.id,
                                        document_id: element.id,
                                        document_name: element.file_name,
                                        friendly_name: element.friendly_name,
                                    }))
                                    html += `<li>
                                        <a href="javascript:void(0);" title="Download this record!"
                                        data-action="documentRecordDownload"
                                        data-doc="${encoded}">
                                            ${ element.friendly_name }
                                        </a>
                                    </li>
                                    `
                                });
                                html += `</ul>`
                            }
                            
                        } else if (f.document_name) {
                            const encoded = encodeURIComponent(JSON.stringify({
                                id: f.id,
                                document_id: null,
                                document_name: f.document_name,
                                friendly_name: f.document_name,
                            }))
                            html += `<br>
                                <hr/>
                                <a href="javascript:void(0);" title="Download this record!"
                                    data-action="documentRecordDownload"
                                    data-doc="${encoded}">
                                    ${ f.document_name }
                                </a>
                            `
                        }
                        if (f.mailgun_logs) {
                            html += this.getLogHtml(f.mailgun_logs)
                        }
                        return html
                    }
                },
            },
            tableKey: 0,
            showMailgunRawData: false,
            selectedRawData: null,
            showDownloadHistoryModal: false,
            recordDownloadHistory: [],
            searchFields: {
                dateStart: null,
                dateEnd: null,
            },
            errors: {
                date_start:null,
                date_end:null,
            },
        }    
    },
    methods: {
        addDocumentClickHandler() {
            this.$nextTick(() => {
                const table = this.$el.querySelector('.dataTable');
                if (table) {
                    table.removeEventListener('click', this.handleDocumentClick); // avoid duplicate bindings
                    table.addEventListener('click', this.handleDocumentClick);
                }
            });
        },
        doSearch() {
            const ajaxUrl = `${this.$api}${this.bookingID}/get-booking-history`;
            const queryString = new URLSearchParams();

            if(this.searchFields.dateStart && this.searchFields.dateEnd){
                queryString.set('search_by_start', this.searchFields.dateStart);
                queryString.set('search_by_end', this.searchFields.dateEnd);
            }

            const urlWithParams = `${ajaxUrl}?${queryString.toString()}`;

            // Update the datatable's AJAX URL with the Start Date & End Date query parameters
            this.options.ajax.url = urlWithParams;

            // Increment the tableKey to force re-render and fetch new data
            this.tableKey++;
        },
        resetSearch() {
            this.searchFields.dateStart = null;
            this.searchFields.dateEnd = null;
            this.errors.date_start = null;
            this.errors.date_end = null;

            // Reset the AJAX URL to the original endpoint without query parameters
            this.options.ajax.url = `${this.$api}${this.bookingID}/get-booking-history`;

            // Increment the tableKey to force re-render and fetch new data
            this.tableKey++;
        },
        handleDocumentClick(e) {
            const link = e.target.closest('[data-action="documentRecordDownload"]');
            if (!link) return;

            const encoded = link.getAttribute('data-doc');
            if (!encoded) return;

            try {
                const docData = JSON.parse(decodeURIComponent(encoded));
                this.downloadDocument(docData);
            } catch (error) {
                console.error('Invalid document data:', error);
            }
        },
        downloadDocument(docData) {
            this.$store.dispatch('setLoadStatus')
            let documentName = docData.friendly_name

            fetch(`${this.$api}download-booking-history-document`, {
                method: 'POST',
                body: JSON.stringify({...docData}),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then((res) => {
                if(res.status === 200) {
                    this.$store.dispatch('setLoadStatus')
                    res.blob().then(response => {
                        const _url = window.URL.createObjectURL(response)
                        const link = document.createElement('a')
                        link.href = _url
                        link.setAttribute('download', documentName)
                        document.body.appendChild(link)
                        link.click();
                    })
                } else {
                    this.$store.dispatch('setLoadStatus')
                    Promise.race([res.json()])
                    .then(response => {
                    if(response.message) {
                        this.$notify({
                        type: 'error',
                        title: response.message
                        });
                    } else {
                        this.$notify({
                        type: 'error',
                        title: response.error
                        });
                    }
                    })
                }
            });
        },
        documentRecordDownload(data) {
            console.log(data);
            return
        },
        documentFromMultipleRecords(data) {
            console.log(data);
        },
        getLogHtml(data) {
            let html = '<hr/>'
            data.forEach(log => { 
                let badgeClass = '';
                let severityClass = '';
                switch(log.event) {
                    case 'accepted':
                        badgeClass = 'badge--accepted';
                        break;
                    case 'delivered':
                        badgeClass = 'badge--delivered';
                        break;
                    case 'failed':
                        badgeClass = 'badge--failed';
                        break;
                    default:
                        badgeClass = 'badge--default';
                }

                switch(log.severity) {
                    case 'temporary':
                        severityClass = 'badge--temporary-failed';
                        break;
                    case 'permanent':
                        severityClass = 'badge--permanent-failed';
                        break;
                    default:
                        severityClass = 'badge--default';
                }

                html+=`
                <div class="row mt-2">
                    <div class="col-md-3">
                        <span class="badge ${badgeClass}">
                            ${log.event}
                        </span>
                        ${ (log.severity) ? `| <span class="badge ${severityClass}">${log.severity}</span>` : '' }
                    </div>
                    <div class="col-md-5" style="border-left: 1px solid #ccc; padding-left: 10px;">
                        <strong>At: </strong> ${this.$options.filters.formatDateTime(log.occurred_at)} <br/>
                    </div>
                    <div class="col-md-4">
                        <div class="row">
                            ${log.event === 'failed' ? `
                                <div class="col-md-3">
                                    <button class="button button--small button--neutral" data-action="viewRawLog">
                                        <span class="icon icon--details"></span>
                                    </button>
                                </div>
                            ` : ''}
                            ${log.severity === 'permanent' ? `
                                <div class="col-md-6">
                                    <button class="button button--small btn-outline-danger" data-action="resendEmail">
                                        <span class="icon icon--email"></span> Resend
                                    </button>
                                </div>
                            ` : ''}
                        </div>
                    </div>


                </div>`
            })
            return html;
        },
        viewRawLog(record) {
            console.log(record);
            if (record.mailgun_logs && record.mailgun_logs.length > 0) {
                const failed_data = record.mailgun_logs.find(log => log.event === 'failed');
                if (!failed_data) {
                    this.$notify({
                        type: 'info',
                        title: 'No failed mailgun log found for this record.'
                    });
                    return;
                }
                this.selectedRawData = failed_data.raw;
                this.showMailgunRawData = true;
                this.$nextTick(() => {
                    const pre = this.$el.querySelector('.modal-lg .modal__body pre code');
                    if (pre) {
                        pre.textContent = JSON.stringify(this.selectedRawData, null, 2);
                        // Apply syntax highlighting if needed
                        if (window.hljs) {
                            window.hljs.highlightElement(pre);
                        }
                    }
                });
            }
        },
        resendEmail(record) {
            if (!record.mailgun_logs || record.mailgun_logs.length === 0)  {
                return false
            }
            const failed_data = record.mailgun_logs.find(log => log.event === 'failed');
            if (!failed_data) {
                this.$notify({
                    type: 'info',
                    title: 'No failed mailgun log found for this record.'
                });
                return;
            }
            console.log('Resend email for record:', failed_data);
            this.$store.dispatch('setLoadStatus')
            fetch(`${this.$api}mailgun/resend`, {
                method: 'POST',
                body: JSON.stringify({
                    id: failed_data.id,
                }),
                headers:{
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then((res) => {
                if (res.status) {
                    this.$toast.success('Email resend initiated successfully.');
                } else {
                    this.$toast.error(res.message || 'Failed to initiate email resend.');
                }
                this.$store.dispatch('setLoadStatus')
            })
            .catch(() => {
                this.$toast.error('An error occurred while trying to resend the email.');
                this.$store.dispatch('setLoadStatus')
            });
        },
        showDownloadHistory(record) {
            this.recordDownloadHistory = record.download_history;
            this.showDownloadHistoryModal = true;
        }
    }
}
</script>
